import { useEffect, useState } from "react";

export const checkFilter = (template, filter) => {
  if (filter.options.filter((o) => o.checked).length == 0) {
    return true;
  }
  const options = filter.options.filter((option) => option.checked);

  console.log('Options is', options);

  for (const option of options) {
    if (filter.filterFunction(template, option.value)) {
      return true;
    }
  }
  return false;
};

export default (templateList, filters) => {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    if (!filters || !templateList) {
      return;
    }

    const filteredTemplateList = templateList.templates.filter((template) => {
      for (const filter of filters) {
        if (!checkFilter(template, filter)) {
          return false;
        }
      }
      return true;
    });

    console.log('Filtered list', filteredTemplateList);

    setTemplates(filteredTemplateList);
  }, [templateList, filters]);

  return templates;
};
